import {Component} from '@angular/core';
import {IonicModule} from '@ionic/angular';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styles: [`
    :host {
      @apply h-full flex items-center justify-center p-4;
    }
  `],
  imports: [
    IonicModule
  ],
  standalone: true
})
export class PageLoaderComponent {
}
